import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

/**
 *
 * @param {*} props.data
 * id -> product id from products.json
 */
const ProductItemCard = (props) => {
  const [prod, setProd] = useState({});
  const products = useSelector((state) => state.product.products);
  if (props.data) {
    var { id } = props.data;
  }
  useEffect(() => {
    setProd(products.find((p) => p.id === id));
  }, [products.size, products, prod, id]);
  if (prod)
    return (
      <a className={`row `} href={`/product/${id}`}>
        <div className="col-md-9 d-flex flex-column align-items-start">
          {prod.name && (
            <h2 className="fw-normal d-flex flex-column">
              {prod.img && (
                <img
                  className="col-md-3 center w-100px "
                  src={prod.img}
                  alt=""
                />
              )}
              <span>{prod.name}</span>
            </h2>
          )}
          {prod.description && (
            <p className="fw-normal fs-9">{prod.description}</p>
          )}
        </div>

        {/* {isSale && <span className="triangle">Sale</span>} */}
      </a>
    );
};

export default ProductItemCard;
